import Vue from 'vue'
import Vuex from 'vuex'
import homeStore from './modules/home'
import listingStore from './modules/listing'
import soldPropertyStore from './modules/soldproperty'
import testimonialStore from './modules/testimonial'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    homeStore,
    listingStore,
    soldPropertyStore,
    testimonialStore
  }
})

export default store
